import './AppDeletePopup.scss'
import Popup from '../../components/popup/Popup'
import { AppFlex } from '../../shared/ui/AppFlex/AppFlex'
import AppBtn, { AppBtnColor, AppBtnSize } from '../../components/btn/AppBtn'
import { useTranslation } from 'react-i18next'

interface AppDeletePopupProps {
  onClose: () => void
  onDelete: () => void
}

export const AppDeletePopup = ({ onClose, onDelete }: AppDeletePopupProps) => {
  const { t } = useTranslation()
  const onDeleteHandler = () => {
    onDelete()
    onClose()
  }

  return (
    <Popup closePopup={onClose}>
      <AppFlex
        gap="20"
        direction="column"
        fullWidth
        className="delete-from-main-server"
      >
        <div className="title">
          <span>{t('Удалить')}:</span>
          <div className="ico-block" onClick={onClose}>
            <i className="an-ico an-ico-close" />
          </div>
        </div>
        <div className="buttons-block full-width mt-15">
          <AppBtn
            sized={AppBtnSize.md}
            color={AppBtnColor.outlineViolet}
            title="Отмена"
            iconClassName="close"
            onClick={onClose}
          />
          <AppBtn
            sized={AppBtnSize.md}
            color={AppBtnColor.violetWhite}
            title="Удалить"
            onClick={onDeleteHandler}
          />
        </div>
      </AppFlex>
    </Popup>
  )
}
